import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-white/90">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-flower-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading font-semibold text-white">
                樱花动漫
              </span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              专注动漫的在线观看平台，为您提供海量高清动漫资源。无需注册，随时随地沉浸在精彩的动漫世界中。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="/category/action" className="hover:text-primary-300 transition-colors">动漫分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/action" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">热血战斗</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">奇幻冒险</Link></li>
              <li><Link to="/category/romance" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">恋爱日常</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">搞笑喜剧</Link></li>
              <li><Link to="/category/mystery" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">悬疑推理</Link></li>
              <li><Link to="/category/scifi" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">科幻未来</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="/about" className="hover:text-primary-300 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><a href="/about#contact" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">联系我们</a></li>
              <li><Link to="/" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">最新动漫</Link></li>
              <li><Link to="/" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">热门推荐</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关注我们</h4>
            <div className="flex items-center gap-3 mb-4">
              <a href="#" rel="nofollow" aria-label="微博" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="微信" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="B站" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" rel="nofollow" aria-label="GitHub" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-github-line"></i>
              </a>
            </div>
            <p className="text-sm text-white/60">
              客服邮箱：contact@sakura-anime.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} 樱花动漫网 - 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" rel="nofollow" className="text-sm text-white/40 hover:text-white/70 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" rel="nofollow" className="text-sm text-white/40 hover:text-white/70 transition-colors cursor-pointer">使用条款</a>
            <a href="#" rel="nofollow" className="text-sm text-white/40 hover:text-white/70 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}